module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.clickaway),
      expression: "clickaway"
    }],
    staticClass: "no-print"
  }, [_c('div', {
    staticClass: "sidebar-nav"
  }, [_c('nav', {
    staticClass: "nav",
    attrs: {
      "aria-label": _vm.$t('vue2.a11y.mainNav')
    }
  }, [(_vm.userHasPermission('can_see_other_calendars') || (_vm.userHasMultipleSchools && !_vm.userHasPermission('can_see_other_calendars'))) ? _c('div', {
    staticClass: "docendo-logo box-shadow"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === false),
      expression: "open === false"
    }],
    staticClass: "docendo-logo__icon icon-docendo",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.openMenu'),
      "aria-expanded": _vm.open ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        return _vm.openSideNav(0)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.openSideNav(0)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.openSideNav(0)
      }]
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === true),
      expression: "open === true"
    }],
    staticClass: "icon-cross2 font-large",
    staticStyle: {
      "padding": "18px"
    },
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.closeMenu'),
      "aria-expanded": _vm.open ? 'true' : 'false'
    },
    on: {
      "click": _vm.closeSideNav,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.closeSideNav.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.closeSideNav.apply(null, arguments)
      }]
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.userHasPermission('can_see_other_calendars') && !_vm.userHasMultipleSchools) ? _c('div', {
    staticClass: "docendo-logo docendo-logo__not-active box-shadow"
  }, [_c('span', {
    staticClass: "docendo-logo__icon icon-docendo"
  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('ul', {
    on: {
      "click": _vm.openSideNav
    }
  }, [(_vm.isKindergarten) ? _c('li', {
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToDutySchedule.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToDutySchedule.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.goToDutySchedule.apply(null, arguments)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Vagtplan\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__kindergarten gtm",
    class: {
      active: _vm.isActive(7)
    },
    attrs: {
      "data-gtm": "SideNav__club",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(7) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(7)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(7)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(7)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Stuer\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__klass gtm test-2",
    class: {
      active: _vm.isActive(1)
    },
    attrs: {
      "data-gtm": "SideNav__klass",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(1) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(1)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(1)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-calendar4 gtm",
    attrs: {
      "data-gtm": "SideNav__klass",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.classes_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__users gtm",
    class: {
      active: _vm.isActive(2)
    },
    attrs: {
      "data-gtm": "SideNav__users",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(2) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(2)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(2)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(2)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-users gtm",
    attrs: {
      "data-gtm": "SideNav__users",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.users')) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__location gtm",
    class: {
      active: _vm.isActive(3)
    },
    attrs: {
      "data-gtm": "SideNav__location",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(3) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(3)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(3)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(3)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-location gtm",
    attrs: {
      "data-gtm": "SideNav__location",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.rooms')) + "\n        ")]), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__merge gtm",
    class: {
      active: _vm.isActive(4)
    },
    attrs: {
      "data-gtm": "SideNav__merge",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(4) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(4)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(4)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(4)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-calendar-week gtm",
    attrs: {
      "data-gtm": "SideNav__merge",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.merge_calendars_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__other gtm",
    class: {
      active: _vm.isActive(5)
    },
    attrs: {
      "data-gtm": "SideNav__other",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(5) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(5)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(5)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(5)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-clipboard2 gtm",
    attrs: {
      "data-gtm": "SideNav__other",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.other_calendars')) + "\n        ")]), _vm._v(" "), (_vm.isSchoolSFOActive && !_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__club gtm",
    class: {
      active: _vm.isActive(6)
    },
    attrs: {
      "data-gtm": "SideNav__club",
      "role": "button",
      "tabindex": "0",
      "aria-current": _vm.isActive(6) ? 'true' : null
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(6)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateNav(6)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.activateNav(6)
      }]
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.club.club')) + "\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav__snow"
  }, _vm._l((_vm.snowflakes), function(flake, index) {
    return _c('span', {
      key: 'snowflake-' + index,
      staticClass: "sidebar-nav__snowflake",
      style: ({
        left: flake.left + '%',
        animationDuration: flake.duration + 's',
        animationDelay: flake.delay + 's',
        width: flake.size + 'px',
        height: flake.size + 'px',
        opacity: flake.opacity
      })
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav__container",
    class: [{
      sidebar_nav_container_show: _vm.open
    }]
  }, [_c('div', {
    staticClass: "sidebar-nav__container__header box-shadow flex"
  }, [_c('div', {
    staticClass: "flex flex-vertical-center",
    staticStyle: {
      "width": "85%"
    }
  }, [_c('h2', [(_vm.activeSchool) ? _c('a', {
    staticClass: "link-white",
    attrs: {
      "href": '/schools/' + _vm.activeSchool.id
    }
  }, [_vm._v(_vm._s(_vm.activeSchool.name))]) : _vm._e()])]), _vm._v(" "), _c('span', {
    ref: "changeSchoolToggle",
    staticClass: "icon-arrow-down5 arrow-dropdown",
    class: {
      active: _vm.changeSchoolDropdown
    },
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.changeSchool'),
      "aria-expanded": _vm.changeSchoolDropdown ? 'true' : 'false'
    },
    on: {
      "click": _vm.toggleChangeSchoolDropdown,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggleChangeSchoolDropdown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.toggleChangeSchoolDropdown.apply(null, arguments)
      }]
    }
  }), _vm._v(" "), (_vm.changeSchoolDropdown) ? _c('div', {
    staticClass: "sidebar-nav__container--dropdown bg-light-blue box-shadow pos-absolute z-index-1000 text-white width-100 box-sizing"
  }, [_c('list-with-search', {
    attrs: {
      "selected": _vm.activeSchool,
      "options": _vm.allSchools
    },
    on: {
      "choose": _vm.toggleChangeSchoolDropdown,
      "close": _vm.closeChangeSchoolDropdown
    }
  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length < 1) ? [_c('div', {
    staticClass: "no-cals"
  }, [_c('div', {
    staticClass: "no-cals__icon"
  }, [_c('span', {
    class: _vm.activeType.icon
  })]), _vm._v(" "), _c('p', {
    staticClass: "no-cals__text",
    domProps: {
      "innerHTML": _vm._s(_vm.notCreatedAnyTextString)
    }
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-link__container"
  }, [(_vm.isActive(1) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createKlasses.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.createKlasses.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.createKlasses.apply(null, arguments)
      }]
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 1 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(2) && _vm.userHasPermission('can_manage_users')) ? _c('a', {
    staticClass: "create-cal__button",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createUsers.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.createUsers.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.createUsers.apply(null, arguments)
      }]
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 2 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(3) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }]
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 3 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(4) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }]
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 4 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.isActive(5) || _vm.isActive(6) || _vm.isActive(7)) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }]
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))])]) : _vm._e()]), _vm._v(" "), (_vm.activeType.hasSchoolYear) ? _c('ChangeSchoolYear', {
    staticStyle: {
      "margin": "10px 15px 0"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length > 0) ? _c('div', {
    staticClass: "sidebar-nav__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchfield",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.common.search_for') + ' ' + _vm.searchName,
      "id": "searchfield"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.focusCalLink(0)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.chooseFirstCalLink.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search !== ''),
      expression: "search !== ''"
    }],
    staticClass: "sidebar-nav__search__cross pointer icon-cross2",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.clearSearch')
    },
    on: {
      "click": _vm.clearSearch,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clearSearch.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.clearSearch.apply(null, arguments)
      }]
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars')) ? _c('div', {
    staticClass: "sidebar-nav__container__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#3e4450"
    }
  })], 1) : [_c('ul', {
    ref: "calList",
    staticClass: "nav__cal-list",
    on: {
      "keydown": _vm.onCalListKeydown
    }
  }, _vm._l((_vm.searchCals), function(cal) {
    return _c('li', {
      key: cal.id
    }, [(cal.type !== 'klass') ? [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
      attrs: {
        "href": cal.url
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }]
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))])] : _vm._e(), _vm._v(" "), (cal.type === 'klass') ? _c('div', {
      staticClass: "nav__cal-list__item",
      class: {
        'nav__cal-list__item--open': _vm.isStudentsActiveForCal(cal.id)
      }
    }, [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
      attrs: {
        "href": cal.url
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }]
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]), _vm._v(" "), (cal.students && cal.students.length > 0) ? _c('div', {
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": _vm.$t('vue2.a11y.showStudents'),
        "aria-expanded": _vm.isStudentsActiveForCal(cal.id) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.setTheStudentsActiveForCal(cal.id)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.setTheStudentsActiveForCal(cal.id)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
          return _vm.setTheStudentsActiveForCal(cal.id)
        }]
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down52",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isStudentsActiveForCal(cal.id)) ? _c('ul', {
      staticClass: "nav__cal-list__item__students"
    }, _vm._l((_vm.getCalStudents(cal.students)), function(student) {
      return _c('li', [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
        attrs: {
          "href": student.url
        }
      }, [_vm._v(_vm._s(student.name ? student.name : student.url))]) : _c('a', {
        attrs: {
          "role": "button",
          "tabindex": "0"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveCalendarId(student.id)
          },
          "keydown": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            $event.preventDefault();
            return _vm.setActiveCalendarId(student.id)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
            $event.preventDefault();
            return _vm.setActiveCalendarId(student.id)
          }]
        }
      }, [_vm._v(_vm._s(student.name ? student.name : student.url))])])
    }), 0) : _vm._e()], 2)
  }), 0)]], 2) : _vm._e()], 2), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('TeamCalendar') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6252f8c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNav.vue
// module id = 1957
// module chunks = 1